module.exports = __webpack_public_path__ + "img/img_activation_email_4.b9b233dc.png";